import local from '../classes/local';
import dateFieldValue from '../objects/models/date.field.value';
import useTrait from './use.trait';

export default function useCreateAccountData() {
   const certificationChecked = useTrait(false);
   const confirmEmailAddress = useTrait('');
   const confirmPassword = useTrait('');
   const coverageStartDate = useTrait(dateFieldValue);
   const dateOfBirth = useTrait(dateFieldValue);
   const emailAddress = useTrait('');
   const lastName = useTrait('');
   const medicareNumber = useTrait('');
   const noEmailAddressChecked = useTrait(false);
   const part = useTrait(local.getItem('part', 'A'));
   const password = useTrait('');
   const secretAnswer = useTrait('');
   const secretQuestion = useTrait('');
   const step = useTrait(1);
   const suffix = useTrait('');
   const username = useTrait('');
   const zipCodeOrCity = useTrait('');
   
   const clearStep2 = () => {
      certificationChecked.set(false);
      confirmEmailAddress.set('');
      dateOfBirth.set(dateFieldValue);
      emailAddress.set('');
      lastName.set('');
      noEmailAddressChecked.set(false);
      suffix.set('');
      zipCodeOrCity.set('');
   };
   
   const clearStep3 = () => {
      username.set('');
      password.set('');
      confirmPassword.set('');
      secretQuestion.set('');
      secretAnswer.set('');
   };
   
   const reset = () => {
      coverageStartDate.set(dateFieldValue);
      medicareNumber.set('');
      clearStep2();
      clearStep3();
      step.set(1);
   };
   
   const stepBackward = () => {
      if (step.get() === 2)
         clearStep2();
      else if (step.get() === 3)
         clearStep3();
      if (step.get() < 2)
         return;
      step.set(step.get() - 1);
   };
   
   const stepForward = () => {
      if (step.get() > 2)
         return;
      step.set(step.get() + 1);
   };
   
   return {
      certificationChecked,
      clearStep2,
      clearStep3,
      confirmPassword,
      confirmEmailAddress,
      coverageStartDate,
      dateOfBirth,
      emailAddress,
      lastName,
      medicareNumber,
      noEmailAddressChecked,
      part,
      password,
      reset,
      secretAnswer,
      secretQuestion,
      step,
      stepBackward,
      stepForward,
      suffix,
      username,
      zipCodeOrCity,
   };
}